import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "shadow-box data-line"
};
const _hoisted_2 = {
  class: "item"
};
const _hoisted_3 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_4 = {
  class: "item"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "item"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  style: {
    "width": "100%",
    "height": "300px"
  },
  ref: "chartContain"
};
const _hoisted_11 = {
  class: "shadow-box data-line"
};
const _hoisted_12 = {
  class: "item"
};
const _hoisted_13 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_14 = {
  class: "item"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = {
  class: "item"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  class: "grids"
};
const _hoisted_21 = {
  class: "shadow-box data-line"
};
const _hoisted_22 = {
  class: "item"
};
const _hoisted_23 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_24 = {
  class: "item"
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  key: 1
};
const _hoisted_27 = {
  class: "item"
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  key: 1
};
const _hoisted_30 = {
  class: "grids"
};
const _hoisted_31 = {
  class: "footer-grids"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_data_card = _resolveComponent("data-card");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createBlock(_component_el_row, {
    gutter: 12
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("label", null, "素材总量 ", -1)), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.sumData.count), 1)]), _createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("label", null, "本日新增 ", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.sumData.day.count), 1), _createElementVNode("span", {
        class: _normalizeClass({
          increment: _ctx.sumData.day.inr,
          nOIncrement: !_ctx.sumData.day.inr
        })
      }, [_createTextVNode(" " + _toDisplayString(_ctx.sumData.day.proportion), 1), _ctx.sumData.day.inr ? (_openBlock(), _createElementBlock("span", _hoisted_5, "↑")) : (_openBlock(), _createElementBlock("span", _hoisted_6, "↓"))], 2)]), _createElementVNode("div", _hoisted_7, [_cache[2] || (_cache[2] = _createElementVNode("label", null, "本周新增 ", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.sumData.week.count), 1), _createElementVNode("span", {
        class: _normalizeClass({
          increment: _ctx.sumData.week.inr,
          nOIncrement: !_ctx.sumData.week.inr
        })
      }, [_createTextVNode(" " + _toDisplayString(_ctx.sumData.week.proportion), 1), _ctx.sumData.week.inr ? (_openBlock(), _createElementBlock("span", _hoisted_8, "↑")) : (_openBlock(), _createElementBlock("span", _hoisted_9, "↓"))], 2)])]), _createElementVNode("div", _hoisted_10, null, 512)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[3] || (_cache[3] = _createElementVNode("label", null, "在途素材 ", -1)), _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.onLineData.count), 1)]), _createElementVNode("div", _hoisted_14, [_cache[4] || (_cache[4] = _createElementVNode("label", null, "本日新增 ", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.onLineData.day.count), 1), _createElementVNode("span", {
        class: _normalizeClass({
          increment: _ctx.onLineData.day.inr,
          nOIncrement: !_ctx.onLineData.day.inr
        })
      }, [_createTextVNode(" " + _toDisplayString(_ctx.onLineData.day.proportion), 1), _ctx.onLineData.day.inr ? (_openBlock(), _createElementBlock("span", _hoisted_15, "↑")) : (_openBlock(), _createElementBlock("span", _hoisted_16, "↓"))], 2)]), _createElementVNode("div", _hoisted_17, [_cache[5] || (_cache[5] = _createElementVNode("label", null, "本周新增 ", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.onLineData.week.count), 1), _createElementVNode("span", {
        class: _normalizeClass({
          increment: _ctx.onLineData.week.inr,
          nOIncrement: !_ctx.onLineData.week.inr
        })
      }, [_createTextVNode(" " + _toDisplayString(_ctx.onLineData.week.proportion), 1), _ctx.onLineData.week.inr ? (_openBlock(), _createElementBlock("span", _hoisted_18, "↑")) : (_openBlock(), _createElementBlock("span", _hoisted_19, "↓"))], 2)])]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_data_card, {
        title: "待入库的设计素材",
        dataObj: _ctx.deviseData
      }, null, 8, ["dataObj"]), _createVNode(_component_data_card, {
        title: "待入库的短信素材",
        dataObj: _ctx.shortMsgData
      }, null, 8, ["dataObj"])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_cache[6] || (_cache[6] = _createElementVNode("label", null, "在途设计需求 ", -1)), _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.lineDemand.count), 1)]), _createElementVNode("div", _hoisted_24, [_cache[7] || (_cache[7] = _createElementVNode("label", null, "本日新增 ", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.lineDemand.day.count), 1), _createElementVNode("span", {
        class: _normalizeClass({
          'increment': _ctx.lineDemand.day.inr,
          'nOIncrement': !_ctx.lineDemand.day.inr
        })
      }, [_createTextVNode(" " + _toDisplayString(_ctx.lineDemand.day.proportion), 1), _ctx.lineDemand.day.inr ? (_openBlock(), _createElementBlock("span", _hoisted_25, "↑")) : (_openBlock(), _createElementBlock("span", _hoisted_26, "↓"))], 2)]), _createElementVNode("div", _hoisted_27, [_cache[8] || (_cache[8] = _createElementVNode("label", null, "本周新增 ", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.lineDemand.week.count), 1), _createElementVNode("span", {
        class: _normalizeClass({
          'increment': _ctx.lineDemand.week.inr,
          'nOIncrement': !_ctx.lineDemand.week.inr
        })
      }, [_createTextVNode(" " + _toDisplayString(_ctx.lineDemand.week.proportion), 1), _ctx.lineDemand.week.inr ? (_openBlock(), _createElementBlock("span", _hoisted_28, "↑")) : (_openBlock(), _createElementBlock("span", _hoisted_29, "↓"))], 2)])]), _createElementVNode("div", _hoisted_30, [_createVNode(_component_data_card, {
        title: "待审核的设计需求",
        dataObj: _ctx.noCheckDemand
      }, null, 8, ["dataObj"]), _createVNode(_component_data_card, {
        title: "进行中的设计需求",
        dataObj: _ctx.deviseDemand
      }, null, 8, ["dataObj"])])]),
      _: 1
    }), _cache[9] || (_cache[9] = _createElementVNode("div", {
      class: "divider"
    }, null, -1)), _createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_createVNode(_component_data_card, {
        title: "已失效的素材",
        dataObj: _ctx.invalidData
      }, null, 8, ["dataObj"]), _createVNode(_component_data_card, {
        title: "已挂起的素材",
        dataObj: _ctx.suspendData
      }, null, 8, ["dataObj"]), _createVNode(_component_data_card, {
        title: "关闭的需求",
        dataObj: _ctx.closeDemand
      }, null, 8, ["dataObj"]), _createVNode(_component_data_card, {
        title: "已完成的需求",
        dataObj: _ctx.accomplishDemand
      }, null, 8, ["dataObj"])])]),
      _: 1
    })]),
    _: 1
  });
}